import React, { useEffect } from 'react';
import styled from 'styled-components';

import { useConfig } from 'Context/ConfigContext';
import { useDisclosure } from 'Util/Hooks';
import { AspectRatio, Box, Text } from 'Components/Base';
import { get as getTheme } from 'Components/Base/constants';

import useFileUpload from '../../../Domain/useFileUpload';
import { useClearByOnDemand } from '../Contexts/ClearByOnDemandProvider';
import ClearImageUploadView from '../Components/ClearImageUpload';
import ClearFileExceedModal from '../Components/ClearFileExceedModal';
import ClearFileSizeExceedModal from '../Components/ClearFileSizeExceedModal';

const ImageScreenShot = styled.img`
  border: 1px solid ${getTheme('colors.greyscale.grey4')};
  border-radius: 8px;
`;

const ClearImageUpload = () => {
  const { classroom: classroomConfig } = useConfig();
  const maximumFileSize = classroomConfig?.clearByOnDemand?.maximumFileSize;
  const fallbackScreenshotUrl =
    classroomConfig?.clearByOnDemand?.fallbackScreenshotUrl ??
    '/assets/images/defaultCourseThumbnail/empty-thumbnail-ANY.png';
  const [isOpenExceedModal, openExceedModal, closeExceedModal] = useDisclosure();
  const [isFileSizeExceedModalOpen, openFileSizeExceedModal, closeFileSizeExceedModal] =
    useDisclosure();
  const [, ticket, { setAttachment }, , { enableScreenshot }] = useClearByOnDemand();
  const images = ticket?.images ?? [];
  const screenshot = ticket?.screenshot ?? [];

  const formattedImages = images.map((image) => image.source);

  const [inputRef, { files, uploadFile, removeFile }] = useFileUpload({
    limit: 3,
    initialFile: images,
    maximumSize: isNaN(maximumFileSize) ? null : maximumFileSize * 1024 * 1024, // maximumSize in megabyte,
    onFileExceedLimit: openExceedModal,
    onFileSizeExceedLimit: openFileSizeExceedModal,
  });

  useEffect(() => setAttachment(files), [setAttachment, files]);

  return (
    <>
      <Text textStyle={'subtitle1'}>รูปประกอบคำถาม</Text>
      <Text textStyle={'body2'} mt={2}>
        น้องสามารถเพิ่มรูปได้สูงสุด 3 รูป
      </Text>
      {enableScreenshot && (
        <AspectRatio ratio={16 / 9} mt={4}>
          <ImageScreenShot
            src={screenshot.source ?? fallbackScreenshotUrl}
            alt={'clear-by-on-demand-screenshot'}
            onError={(e) => {
              console.error(`${e.target.src} 404 not found`);
              e.target.onerror = null;
              e.target.src = fallbackScreenshotUrl;
            }}
          />
        </AspectRatio>
      )}
      <Box mt={4}>
        <ClearImageUploadView
          images={formattedImages}
          onAddImage={uploadFile}
          onRemoveImage={removeFile}
        />
      </Box>
      <input
        ref={inputRef}
        type={'file'}
        accept={'image/jpg, image/jpeg, image/png'}
        multiple
        hidden
      />

      <ClearFileExceedModal
        muiProps={{ isActive: isOpenExceedModal }}
        onContinue={closeExceedModal}
      />
      <ClearFileSizeExceedModal
        muiProps={{ isActive: isFileSizeExceedModalOpen }}
        onContinue={closeFileSizeExceedModal}
        maximumFileSize={`${maximumFileSize}`}
      />
    </>
  );
};

export default ClearImageUpload;
